import i18n from "locales/i18next";
import memoizeOne from "memoize-one";
import _values from 'lodash/values';

export interface Option {
    option: string | number;
    label: string;
    disabled?: boolean;
}

export interface Attribute {
    label: string;
    name: string;
    type: string;
    options?: Option[];
}

export const getPeeringAttributes = memoizeOne((t: i18n.TFunction): { [key: string]: Attribute } => {
    return {
        'peer-group': {
            label: 'Peer group',
            name: 'peer-group',
            type: 'text'
        },
        'password': {
            label: 'Password',
            name: 'password',
            type: 'text'
        },
        'filtering': {
            label: 'Filtering',
            name: 'filtering',
            type: 'select',
            options: [{
                option: '',
                disabled: true,
                label: t('peering.selectFiltering')
            }, {
                option: 'tag-only',
                label: t('common.tagOnly')
            }, {
                option: 'rpki+irrdb',
                label: t('common.rpkiIrrdb')
            }, {
                option: 'irrdb',
                label: t('common.irrdb')
            }, {
                option: 'rpki',
                label: t('common.rpki')
            }]
        },
        'ttl': {
            label: 'TTL',
            name: 'ttl',
            type: 'text'
        },
        'prefix_limit_v4': {
            label: 'Prefix limit v4',
            name: 'prefix_limit_v4',
            type: 'text'
        },
        'prefix_limit_v6': {
            label: 'Prefix limit v6',
            name: 'prefix_limit_v6',
            type: 'text'
        },
        'as_set_v4': {
            label: 'AS SET v4',
            name: 'as_set_v4',
            type: 'text'
        },
        'as_set_v6': {
            label: 'AS SET v6',
            name: 'as_set_v6',
            type: 'text'
        },
        'maps_microsoft': {
            label: 'Maps Microsoft',
            name: 'maps_microsoft',
            type: 'text'
        },
        'maps_client': {
            label: 'Maps Client',
            name: 'maps_client',
            type: 'text'
        }
    };
});

export const getPeeringAttributesList = memoizeOne((t: i18n.TFunction): Attribute[] => _values(getPeeringAttributes(t)));